import { render } from "./StepProduct.vue?vue&type=template&id=662b35bd&scoped=true"
import script from "./StepProduct.vue?vue&type=script&lang=js"
export * from "./StepProduct.vue?vue&type=script&lang=js"

import "./StepProduct.vue?vue&type=style&index=0&id=662b35bd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-662b35bd"]])

export default __exports__